import {DeviceListScreen} from './DeviceListScreen';
import {RouteDefinition} from '../../../routes';
import {DeviceEditScreen} from './DeviceEditScreen';
import {DeviceSettingsScreen} from './DeviceSettingsScreen';

export const DeviceSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/device/edit',
        component: DeviceEditScreen,
    },
    {
        routerLink: '/settings/device/edit/:id',
        component: DeviceEditScreen,
    },
    {
        routerLink: '/settings/device/device-settings/:id',
        component: DeviceSettingsScreen,
    },
    {
        routerLink: '/settings/device',
        component: DeviceListScreen,
    },
];
